import React from 'react'
import { Grid, Stack, Typography } from '@mui/material'
import { Avatar, BoxWithLabel } from '../../../../../common/components'
import { calculateAge } from '../../utils/patient-profile.utils'
import { useTranslation } from '../../../../../common/hooks'
import { DoctorPatientProfile } from '../../types/doctorPatients.types'

interface PatientBasicSectionProps {
  patientProfile: DoctorPatientProfile
}

export const PatientBasicSection: React.FC<
  React.PropsWithChildren<PatientBasicSectionProps>
> = ({ patientProfile }) => {
  const { t } = useTranslation()

  return (
    <Stack>
      <Stack direction="row" alignItems="center" mb={1.5}>
        <Avatar
          firstName={patientProfile.firstName}
          lastName={patientProfile.lastName}
          size={'large'}
        />
        <Stack>
          <Typography variant="body2" fontWeight={500}>
            {t('common:formattedNameFull', {
              firstName: patientProfile.firstName,
              lastName: patientProfile.lastName,
              title: patientProfile.title,
            })}
          </Typography>

          <BoxWithLabel size="small" label={t('patients:taj')}>
            <Typography variant="body2" fontWeight={500}>
              {patientProfile.tajNumber}
            </Typography>
          </BoxWithLabel>
        </Stack>
      </Stack>

      <Grid container mb={0.5}>
        <Grid item xs={6}>
          <BoxWithLabel size="small" label={t('patients:gender')}>
            <Typography variant="body2">
              {t(`patients:genders.${patientProfile.gender}`)}
            </Typography>
          </BoxWithLabel>
        </Grid>
        <Grid item xs={6}>
          <BoxWithLabel size="small" label={t('patients:filters.age.title')}>
            <Typography variant="body2">
              {calculateAge(patientProfile.birthDate)}
            </Typography>
          </BoxWithLabel>
        </Grid>
      </Grid>

      <Grid container mb={0.5}>
        <Grid item xs={6}>
          <BoxWithLabel size="small" label={t('common:birthdate')}>
            <Typography variant="body2">
              {
                t('common:dateFormatted', {
                  date: patientProfile.birthDate,
                }) as string
              }
            </Typography>
          </BoxWithLabel>
        </Grid>
        <Grid item xs={6}>
          <BoxWithLabel size="small" label={t('patients:birthplace')}>
            <Typography variant="body2">
              {patientProfile.birthPlace ?? '-'}
            </Typography>
          </BoxWithLabel>
        </Grid>
      </Grid>

      <Grid container mb={0.5}>
        <Grid item xs={12}>
          <BoxWithLabel size="small" label={t('patients:mothersName')}>
            <Typography variant="body2">
              {
                t('common:formattedName', {
                  firstName: patientProfile.motherFirstName,
                  lastName: patientProfile.motherLastName,
                }) as string
              }
            </Typography>
          </BoxWithLabel>
        </Grid>
      </Grid>
    </Stack>
  )
}
